import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["navElement", "justify", "background", "children", "isMobileDropdown", "testId", "additionalContentEl"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Children, cloneElement } from 'react';
import { Logo } from '@restworld/ui-ds-base';
import { Navbar } from './navigation-bar-styled';
import { NonAuthenticatedNav, MobileOverlayNav } from './navigation-bar.components';
import { LinkBase } from '../../design-system';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var NavigationBar = function NavigationBar(props) {
  var navElement = props.navElement,
      justify = props.justify,
      _props$background = props.background,
      background = _props$background === void 0 ? 'white' : _props$background,
      children = props.children,
      isMobileDropdown = props.isMobileDropdown,
      testId = props.testId,
      additionalContentEl = props.additionalContentEl,
      rest = _objectWithoutProperties(props, _excluded);

  var navigationComponent = navElement ? Children.map(navElement, function (child) {
    return /*#__PURE__*/cloneElement(child, {
      background: background
    });
  }) : null;

  var commonContainer = /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx(_StyledDiv2, {
      children: /*#__PURE__*/_jsx(LinkBase, {
        link: "/",
        newTab: false,
        children: /*#__PURE__*/_jsx(NavLogo, {
          background: background
        })
      })
    }), navigationComponent]
  }); // --- //


  var mobileNav = /*#__PURE__*/_jsx(_StyledDiv3, {
    children: /*#__PURE__*/_jsxs(Navbar, _objectSpread(_objectSpread({
      background: background,
      testId: "mobile-".concat(testId),
      additionalContentEl: additionalContentEl
    }, rest), {}, {
      children: [isMobileDropdown ? commonContainer : navigationComponent, children]
    }))
  });

  var desktopNav = /*#__PURE__*/_jsx(_StyledDiv4, {
    children: /*#__PURE__*/_jsxs(Navbar, _objectSpread(_objectSpread({
      background: background,
      testId: "desktop-".concat(testId),
      additionalContentEl: additionalContentEl
    }, rest), {}, {
      children: [commonContainer, children]
    }))
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [mobileNav, desktopNav]
  });
};
export default NavigationBar;
export var NavLogo = function NavLogo(_ref) {
  var background = _ref.background,
      isSmallLogo = _ref.isSmallLogo;
  var colorClass = background === 'white' ? 'text-purple-700' : 'text-white';
  return /*#__PURE__*/_jsxs(LogoWrapper, {
    $isSmallLogo: isSmallLogo !== null && isSmallLogo !== void 0 ? isSmallLogo : false,
    children: [/*#__PURE__*/_jsx(Logo, {
      variant: "horizontal",
      title: "restworld",
      className: "hidden h-8 w-auto lg:block ".concat(colorClass)
    }), /*#__PURE__*/_jsx(Logo, {
      variant: "mark",
      title: "restworld",
      className: "h-9 w-auto lg:hidden ".concat(colorClass)
    })]
  });
};

var LogoWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "navigation-bar__LogoWrapper",
  componentId: "sc-1hkbda6-0"
})(["", " ", ""], {
  "flexShrink": "0",
  "paddingLeft": "0.5rem"
}, function (_ref2) {
  var $isSmallLogo = _ref2.$isSmallLogo;
  return $isSmallLogo ? {
    "minWidth": "36px"
  } : {
    "minWidth": "40px"
  };
});

export { NonAuthenticatedNav, MobileOverlayNav };
export * from './navigation-bar.components/impression-component';

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "navigation-bar___StyledDiv",
  componentId: "sc-1hkbda6-1"
})({
  "display": "grid",
  "width": "100%",
  "gridTemplateColumns": "repeat(3, minmax(0, 1fr))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "@media (min-width: 1024px)": {
    "minHeight": "97px"
  }
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "navigation-bar___StyledDiv2",
  componentId: "sc-1hkbda6-2"
})({
  "display": "flex",
  "alignItems": "center"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "navigation-bar___StyledDiv3",
  componentId: "sc-1hkbda6-3"
})({
  "display": "block",
  "maxWidth": "100vw",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "navigation-bar___StyledDiv4",
  componentId: "sc-1hkbda6-4"
})({
  "display": "none",
  "maxWidth": "100vw",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});